var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholderFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8054 19.9647C13.2307 19.9647 12.2495 18.2565 13.043 16.8962L16.7692 10.5084C17.5566 9.15867 19.5067 9.15867 20.2941 10.5084L24.0203 16.8962C24.8138 18.2565 23.8326 19.9647 22.2579 19.9647H14.8054Z",
    fill: "#FEEFD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34498 19.9624C0.76649 19.9624 -0.214168 18.2469 0.586819 16.8867L8.03929 4.23157C8.82841 2.89156 10.7665 2.89156 11.5556 4.23157L19.0081 16.8867C19.8091 18.2469 18.8284 19.9624 17.2499 19.9624H2.34498Z",
    fill: "#FFF8EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1555 1.66368C19.1555 2.58251 18.4106 3.32736 17.4918 3.32736C16.573 3.32736 15.8281 2.58251 15.8281 1.66368C15.8281 0.744855 16.573 0 17.4918 0C18.4106 0 19.1555 0.744855 19.1555 1.66368Z",
    fill: "#FEE2B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholderFill);
export default __webpack_public_path__ + "static/media/image-placeholder--fill.7dd21670.svg";
export { ForwardRef as ReactComponent };